import application from 'application/application';

application

	.directive('ngTags', ['$timeout', $timeout => ({
		restrict: 'A',
		link(scope, element) {

			$timeout(() => $(element).tagsinput());

		}
	})]);
